export function AccountOrder() {
  return (
    <path
      stroke="currentColor"
      className="dynamic-stroke-width"
      d="M11.25 14.853v9.78L20 28.75m-8.75-13.897L20 18.97m-8.75-4.118 4.375-1.801m13.125 1.8v9.78L20 28.75m8.75-13.897L20 11.25l-4.375 1.802m13.125 1.8-4.375 2.06M20 18.97v9.779m0-9.78 4.375-2.058m-8.75-3.86 8.75 3.86m0 0v4.89"
    />
  )
}
